import { Button } from 'antd';
import React, { FC } from 'react';
import { ButtonAuthProps } from '/react4xp/parts/button-auth/button-auth.type';
import '/site/parts/button-auth/button-auth.scss';

const ButtonAuth: FC<ButtonAuthProps> = (props: ButtonAuthProps) => {
    const { url, config, user } = props;

    return user ? null : (
        <Button
            type="primary"
            className="medium"
            onClick={() => open(url, '_self')}
            {...props}
        >
            {config.name}
        </Button>
    );
};

export default ButtonAuth;
